import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStudentsIncomes } from "../../../../redux/actions/reportActions";
import { ReactComponent as MoneyIcon } from "../../../../assets/icons/report/money.svg";
import moment from "moment";
import { Tooltip } from "antd";
import { BsInfoCircleFill } from "react-icons/bs";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useCustomHook } from "../../../../globalComponents/GlobalFunctions/globalFunctions";

const Entry = () => {
  const dispatch = useDispatch();
  const today = moment();

  const startDate = today.startOf("month").format("YYYY-MM-DD");
  const endDate = today.endOf("month").format("YYYY-MM-DD");
  const [date, setDate] = useState({ startDate: startDate, endDate: endDate });
  const { studentsIncomes } = useSelector((state) => state.reportDatas);
  const { salesTypeList: salesTypes } = useCustomHook();
  const [selectedSalesType, setSelectedSalesType] = useState("all");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedDate = { ...date, [name]: value };
    setDate(updatedDate);
  };

  useEffect(() => {
    if (date.startDate && date.endDate) {
      dispatch(
        getStudentsIncomes(date.startDate, date.endDate, "", selectedSalesType)
      );
    }
  }, [date, selectedSalesType]);

  const handleKeyDown = (e) => {
    if (date.startDate && date.endDate) {
      dispatch(getStudentsIncomes(date.startDate, date.endDate, ""));
    }
  };

  const data = [
    {
      id: 1,
      name: "Tələbə aylıq ödəniş",
      studentCount: studentsIncomes?.partPaymentStudentIncome,
      info: "Hissəli ödəniş edən tələbələrin ödənişləri cəmi. Hər statusda tələbələr daxildir.",
    },
    {
      id: 2,
      name: "Tələbə tam ödəniş",
      studentCount: studentsIncomes?.fullPaymentStudentIncome,
      info: "Tam ödəniş edən tələbələrin ödənişləri cəmi. Hər statusda tələbələr daxildir.",
    },
    // {
    //   id: 3,
    //   name: "Gecikmə ödənişi",
    //   studentCount: studentsIncomes?.delayPaymentStudentIncome,
    // },
    {
      id: 4,
      name: "Yeni qeydiyyat",
      studentCount: studentsIncomes?.waitingStudentIncome,
      info: "Gözləmə statuslu tələbələrin ödənişləri cəmi",
    },
  ];

  return (
    <div className="entry-card">
      <div className="entry-header-wrapper">
        <div
          className="entry-header-top"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: "10px",
          }}
        >
          <h2 className="entry-title">Daxilolmalar</h2>
          <div className="entry-icon-wrapper">
            <div className="entry-icon">
              <MoneyIcon />
            </div>
          </div>
        </div>
        <div className="entry-date-container">
          <div className="entry-date-inputs">
            <input
              type="date"
              name="startDate"
              value={date.startDate}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            <input
              type="date"
              name="endDate"
              value={date.endDate}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
          </div>
          <FormControl  style={{ width: "50%" }}>
            <InputLabel id="demo-simple-select-label">Satış növü</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedSalesType}
              label="Satış növü"
              onChange={(e) => setSelectedSalesType(e.target.value)}
              sx={{ fontSize: 12 }}
            >
              <MenuItem value={"all"} sx={{ fontSize: 12 }}>
                Hamısı
              </MenuItem>
              {salesTypes?.map((item, i) => (
                <MenuItem key={i} value={item.key} sx={{ fontSize: 12 }}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div className="entry-list">
        {data.map((item) => (
          <div className="entry-item" key={item.id}>
            <p className="entry-item-title">{item.name}</p>
            <p className="entry-item-value">+{item.studentCount || 0} AZN</p>
            <div style={{ position: "absolute", right: "0px", top: "0px" }}>
              <Tooltip
                title={<p style={{ fontSize: "12px" }}>{item.info}</p>}
                sx={{
                  color: "lightgray",
                }}
                placement="right"
              >
                <div>
                  <BsInfoCircleFill
                    style={{
                      position: "static",
                      color: "lightgray",
                      cursor: "initial",
                      zIndex: 1000,
                      fontSize: "13px",
                    }}
                  />
                </div>
              </Tooltip>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Entry;
